import axios from 'axios';

export default {
  login({commit}, user){
    return new Promise((resolve, reject) => {
      commit('auth_request');
      axios('/api/login_check',
        {
          method: 'POST',
          data: {username: user.email,password: user.password},
        }
      )
      .then(resp => {

        if(resp.data.user_multifactor_auth == true) {
          commit('mfa_success', resp.data);  
        }
        else {
          commit('auth_success', resp.data);  
        }
        

        resolve(resp);
      })
      .catch(error => {
        commit('auth_error', error.response.data);
        reject(error);
      })
    })
  },
  logout({commit}){
    return new Promise((resolve, reject) => {
      commit('logout');
      //localStorage.removeItem('token')
      resolve();
    })
  },
  registerconfirm({commit}, token){
    return new Promise((resolve, reject) => {
      commit('auth_request');
      axios('/custom/register/confirm',
        {
          method: 'POST',
          data: {token: token},
        }
      )
      .then(resp => {
        commit('auth_success', resp.data);
        resolve(resp);
      })
      .catch(error => {
        commit('auth_error', error.response.data);
        reject(error);
      })
    })
  },
  menteeemailnotification({commit}, token){
    return new Promise((resolve, reject) => {
      commit('auth_request');
      axios('/custom/emailnotification/confirm',
        {
          method: 'POST',
          data: {token: token},
        }
      )
      .then(resp => {
        commit('auth_success', resp.data);
        resolve(resp);
      })
      .catch(error => {
        commit('auth_error', error.response.data);
        reject(error);
      })
    })
  },
  headings_tasks({commit}, data){
    return new Promise((resolve, reject) => {
      commit('headings_tasks', data);
      resolve();
    })
  },
  subtasks({commit}, data){
    return new Promise((resolve, reject) => {
      commit('subtasks', data);
      resolve();
    })
  },
  refresh_token({commit}, data){
    return new Promise((resolve, reject) => {
      commit('refresh_token', data);
      resolve();
    })
  },
  set_flash_msg({commit}, data){
    return new Promise((resolve, reject) => {
      commit('set_flash_msg', data);
      resolve();
    })
  },
  switch_user({commit}, data){
    return new Promise((resolve, reject) => {
      commit('switch_user', data);
      resolve();
    })
  },
  active_tab({commit}, data){
    return new Promise((resolve, reject) => {
      commit('active_tab', data);
      resolve();
    })
  },
  set_user_accountid({commit}, data){
    return new Promise((resolve, reject) => {
      commit('set_user_accountid', data);
      resolve();
    })
  },
  invoice_due_order_id({commit}, data){
    return new Promise((resolve, reject) => {
      commit('invoice_due_order_id', data);
      resolve();
    })
  },
  invoice_due_modal_date({commit}, data){
    return new Promise((resolve, reject) => {
      commit('invoice_due_modal_date', data);
      resolve();
    })
  },
  search_parameters({commit}, data){
    return new Promise((resolve, reject) => {
      commit('search_parameters', data);
      resolve();
    })
  },
  sidebar_menu_minimized({commit}, data){
    return new Promise((resolve, reject) => {
      commit('sidebar_menu_minimized', data);
      resolve();
    })
  },
  switch_admin_user({commit}, data){
    return new Promise((resolve, reject) => {
      commit('switch_admin_user', data);
      resolve();
    })
  },
  tasklist_title({commit}, data){
    return new Promise((resolve, reject) => {
      commit('tasklist_title', data);
      resolve();
    })
  },  
  mmcreateaccountconfirm({commit}, token){
    return new Promise((resolve, reject) => {
      commit('auth_request');
      axios('/custom/create-account/confirm',
        {
          method: 'POST',
          data: {token: token},
        }
      )
      .then(resp => {
        commit('auth_success', resp.data);
        resolve(resp);
      })
      .catch(error => {
        commit('auth_error', error.response.data);
        reject(error);
      })
    })
  },
  set_search_accounts({commit}, data){
    return new Promise((resolve, reject) => {
      commit('set_search_accounts', data);
      resolve();
    })
  },
  clear_search_accounts({commit}){
    return new Promise((resolve, reject) => {
      commit('clear_search_accounts');
      resolve();
    })
  },
  assessment_sections({commit}, data){
    return new Promise((resolve, reject) => {
      commit('assessment_sections', data);
      resolve();
    })
  },
  forms_manager({commit}, data){
    return new Promise((resolve, reject) => {
      commit('forms_manager', data);
      resolve();
    })
  },
  search_enterprise_parameters({commit}, data){
    return new Promise((resolve, reject) => {
      commit('search_enterprise_parameters', data);
      resolve();
    })
  },
  set_search_enterprises({commit}, data){
    return new Promise((resolve, reject) => {
      commit('set_search_enterprises', data);
      resolve();
    })
  },
  clear_search_enterprises({commit}){
    return new Promise((resolve, reject) => {
      commit('clear_search_enterprises');
      resolve();
    })
  },
  search_enterprise_locations({commit}, data){
    return new Promise((resolve, reject) => {
      commit('search_enterprise_locations', data);
      resolve();
    })
  },
  clear_search_enterprise_locations({commit}){
    return new Promise((resolve, reject) => {
      commit('clear_search_enterprise_locations');
      resolve();
    })
  },
  set_user_locations({commit}, data){
    return new Promise((resolve, reject) => {
      commit('set_user_locations', data);
      resolve();
    })
  },
  clear_user_locations({commit}){
    return new Promise((resolve, reject) => {
      commit('clear_user_locations');
       resolve();
    })
  },
  search_enterprise_purchasing_history({commit}, data){
    return new Promise((resolve, reject) => {
      commit('search_enterprise_purchasing_history', data);
      resolve();
    })
  },
  clear_search_enterprise_purchasing_history({commit}){
    return new Promise((resolve, reject) => {
      commit('clear_search_enterprise_purchasing_history');
      resolve();
    })
  },
  set_multi_user_logged_time({commit}, data){
    return new Promise((resolve, reject) => {
      commit('set_multi_user_logged_time', data);
      resolve();
    })
  },
  set_enterprise_type({commit}, data){
    return new Promise((resolve, reject) => {
      commit('set_enterprise_type', data);
      resolve();
    })
  },
  introduction_template({commit}, data){
    return new Promise((resolve, reject) => {
      commit('introduction_template', data);
      resolve();
    })
  },
  introduction_template_display({commit}, data){
    return new Promise((resolve, reject) => {
      commit('introduction_template_display', data);
      resolve();
    })
  },
  pathway_steps({commit}, data){
    return new Promise((resolve, reject) => {
      commit('pathway_steps', data);
      resolve();
    })
  },
  create_account_obj({commit}, data){
    return new Promise((resolve, reject) => {
      commit('create_account_obj', data);
      resolve();
    })
  },
  create_account({commit}, data){
    return new Promise((resolve, reject) => {
      commit('create_account', data);
      resolve();
    })
  },
  mfa_success_data({commit}, data){
    return new Promise((resolve, reject) => {
      commit('auth_success', data);
      resolve();
    })
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js